import { changeCurrentCurrency, fetchCurrencyConversionsIfNeeded } from '@/redux/modules/currency';
import { detectExperiment, setExperiment } from '@/redux/modules/googleOptimize';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getLocale } from '@/redux/modules/intl';
import { getUserExperimentVariant } from '@/redux/modules/userVariantTest';
import React from 'react';

const DEFAULT_CURRENCY_CODE = 'usd';

type OwnProps = {};

const mapStateToProps = (state) => {
    const locale = getLocale(state);
    const userExperiment = getUserExperimentVariant(state, '1MEB3ntxRiKtkXAh4E0diQ');
    let currencyCode =
        userExperiment.variantId && locale === 'en-gb'
            ? String(userExperiment.variantId).toLowerCase()
            : DEFAULT_CURRENCY_CODE;

    return {
        currencyCode,
        locale,
        userExperiment,
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            changeCurrentCurrency,
            detectExperiment,
            fetchCurrencyConversionsIfNeeded,
            setExperiment,
        },
        dispatch
    );

type ReduxProps = {
    currencyCode: string;
    locale: string;
    userExperiment: any;
};

type ReduxActions = {
    changeCurrentCurrency: typeof changeCurrentCurrency;
    detectExperiment: typeof detectExperiment;
    fetchCurrencyConversionsIfNeeded: typeof fetchCurrencyConversionsIfNeeded;
    setExperiment: typeof setExperiment;
};

type Props = OwnProps & ReduxProps & ReduxActions;

class CurrencyExperimentContainer extends React.Component<Props> {
    static defaultProps = {
        currencyCode: DEFAULT_CURRENCY_CODE,
    };

    componentDidMount() {
        this.setupCurrencyExperiment();
    }

    setupCurrencyExperiment = () => {
        if (this.props.locale === 'en-gb') {
            const { currencyCode, userExperiment } = this.props;
            const { experimentId, variantId } = userExperiment;
            if (currencyCode !== DEFAULT_CURRENCY_CODE) {
                this.props.changeCurrentCurrency(currencyCode);
            }
            this.props.fetchCurrencyConversionsIfNeeded();
            this.props.setExperiment(`${experimentId}.${variantId}`);
            this.props.detectExperiment();
        }
    };

    render() {
        return null;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CurrencyExperimentContainer);
